import PropTypes from 'prop-types'

import { TableRow, TableCell } from 'components/Table'
import {
  MenuButton,
  Permitted,
  PaymentOrderButtonAction,
  ChipPaymentOrder,
  VisiblePaymentPaid,
} from 'components'

import helpers from 'helpers'
import constants from 'constants/index'

const PaymentOrdersTableRow = ({ paymentOrder, refresh, setLoading }) => {
  const methodGateway = () => {
    if (
      paymentOrder?.status === constants.paymentOrder.STATUSES.GRATUITY_STATUS
    )
      return '-'

    return `${paymentOrder?.paymentMethod || '-'} (${paymentOrder?.gateway})`
  }

  return (
    <>
      <TableRow key={paymentOrder?.id}>
        <TableCell disableTooltip>{paymentOrder?.id}</TableCell>
        <TableCell>{paymentOrder?.contractIdentifier}</TableCell>
        <TableCell disableTooltip>{methodGateway()}</TableCell>
        <TableCell>{paymentOrder?.preRegistration?.name}</TableCell>
        <TableCell disableTooltip>
          R$ {helpers.formatters.currencyInput(paymentOrder?.price)}
        </TableCell>
        <TableCell disableTooltip align="left">
          {paymentOrder?.expirationDate
            ? helpers.formatters.date(paymentOrder?.expirationDate)
            : '-'}
        </TableCell>
        <TableCell disableTooltip align="left">
          <VisiblePaymentPaid paymentOrder={paymentOrder} />
        </TableCell>
        <TableCell disableTooltip align="left">
          {helpers.formatters.date(
            paymentOrder?.orderReferenceDate,
            'MM/YYYY',
          ) || '-'}
        </TableCell>
        <TableCell>{paymentOrder?.dataNfe?.nNfse || '-'}</TableCell>
        <TableCell disableTooltip noOverFlow align="left">
          <ChipPaymentOrder paymentOrder={paymentOrder} />
        </TableCell>
        <TableCell disableTooltip noOverFlow>
          <Permitted tag={constants.permissions.PAYMENT_ORDERS.MANAGE_PAYMENT}>
            <MenuButton>
              <PaymentOrderButtonAction
                paymentOrder={paymentOrder}
                refresh={refresh}
                setLoading={setLoading}
              />
            </MenuButton>
          </Permitted>
        </TableCell>
      </TableRow>
    </>
  )
}

PaymentOrdersTableRow.propTypes = {
  paymentOrder: PropTypes.object,
}

export default PaymentOrdersTableRow
